// node_modules
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
import _upperFirst from 'lodash/upperFirst'
import _camelCase from 'lodash/camelCase'

// config
import Store from './services/StoreService'
import Router from './services/RouterService'
import Analytics from './services/GoogleAnalyticsService'
import { languages } from './config/global.json'

// services
import i18n from './services/LanguageService'
import fn from './services/GlobalService'

/*
|--------------------------------------------------------------------------
| Register global (base) views
|--------------------------------------------------------------------------
*/
const requireComponent = require.context(
  './views/base',
  false,
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = _upperFirst(
    _camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )
  Vue.component(componentName, componentConfig.default || componentConfig)
})

/*
|--------------------------------------------------------------------------
| Configuration, Pre-Loading
|--------------------------------------------------------------------------
*/
Vue.use(VueAxios, axios)
Vue.use(VueCookie)
Vue.config.productionTip = false

// Language
var locale = VueCookie.get('locale')
if (!locale || !fn.inArray(locale, languages.available)) {
  locale = languages.default
}
var langPromise = Store.dispatch('loadLanguage', locale)
var spritesPromies = Vue.axios.get('/assets/icons/sprites.svg').then((response) => {
  document.getElementById('icons').innerHTML = response.data
})

/*
|--------------------------------------------------------------------------
| Mount application
|--------------------------------------------------------------------------
*/
Promise.all([langPromise, spritesPromies]).then((values) => {
  var page = new Vue({
    el: '#page',
    router: Router,
    store: Store,
    i18n: i18n,
    template: '<router-view></router-view>'
  })
})



// WEBPACK FOOTER //
// ./src/index.js